import React, {useEffect, useState, useGlobal} from "reactn";
import {Table, Space, Button, Input, Popconfirm} from 'antd';
import {Link} from 'react-router-dom';
import firebaseDb from '../firebase';
import {doc, collection, getDocs, deleteDoc, query, orderBy} from 'firebase/firestore';
import {
    EditOutlined,
    DeleteOutlined,
    PlusOutlined,
    Loading3QuartersOutlined,
    FileDoneOutlined
} from "@ant-design/icons";

const QuestionSet = (props) => {

    const {Search} = Input;
    let [data, setData] = useState([]);
    let [totalCount, setTotalCount] = useState(0)
    let [search, setSearch] = useState(false)
    let [loading, setLoading] = useState(false)

    let handleTableChange = async (page, filters, sorter) => {
        get(page, filters, sorter);
    }

    let get = async (page, filters, sorter) => {
        if (page) {
            page = {page: page.current, pageSize: page.pageSize}
        } else {
            page = {page: 1, pageSize: 10};
        }
        let shortString = 'date,time';

        if (sorter) {
            if (Object.keys(sorter).length) {
                shortString = (sorter.order === 'descend' ? '-' : '') + sorter.field
            }
        }

        let _params = {sort: shortString, ...page};

        if (search.length > 2) {
            _params["search"] = search.toLowerCase();
            _params["searchFields"] = "name, email, phone";
        }

        const questionSetRef = collection(firebaseDb, 'questionSet');
        const questionquery = query(questionSetRef, orderBy("name"))
        const questionSetSnapshot = await getDocs(questionquery);
        const questionSetList = questionSetSnapshot.docs.map((doc) => {
            return {
                id: doc.id,
                ...doc.data(),
            }
        });
        setLoading(false)
        setTotalCount(questionSetList.length);
        setData(questionSetList);
    }

    useEffect(() => {
        setLoading(true)
        get();
    }, [])

    useEffect(() => {
        get();
    }, [search]);

    let deleteRow = async (item_id) => {
        await deleteDoc(doc(firebaseDb, "questionSet", item_id));
        let newData = data.filter(el => el.id !== item_id);
        setData(newData)
    }

    let onChange = async (e) => {
        setSearch(e.target.value);
        get();
    }

    let columns = [
        {
            title: 'Başlık',
            dataIndex: 'name',
            key: 'name',
            sortDirections: ['descend', 'ascend']
        },
        {
            title: 'Dil',
            dataIndex: 'lang',
            key: 'lang',
            sortDirections: ['descend', 'ascend']
        },
        {
            title: '',
            key: 'action',
            fixed: 'right',
            align: 'right',
            className: 'editColumn',
            width: 150,
            render: (text, record) => (
                <Space className="gap-8" size="small">
                    <Link to={"/questionSet/edit/" + record.id}>
                        <Button className="button4" icon={<EditOutlined/>}>
                            Düzenle
                        </Button>
                    </Link>
                    <Popconfirm
                        onConfirm={() => deleteRow(record.id)} title="Silmeyi Onaylıyor musunuz?"
                        okText="Onayla" cancelText="Vazgeç">
                        <Button className="button4" type="danger" icon={<DeleteOutlined/>}>
                            Sil
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <div>
            <div className="list-head">
                <div className="list-title">
                    <h1>{"Soru Setleri"}</h1>
                </div>
                <div className="list-buttons div-buttons">
                    <Link to="/questionSet/add">
                        <Button className="button4" type="light" icon={<PlusOutlined/>} size="large">Soru Seti
                            Ekle</Button>
                    </Link>
                </div>
            </div>

            <div className="table-wrap">
                <Table className="button4" dataSource={data} columns={columns}
                       loading={{spinning: loading, indicator: <Loading3QuartersOutlined spin/>, size: "large"}}
                       onChange={handleTableChange}
                       pagination={{
                           total: totalCount
                       }}/>
            </div>

        </div>
    );
};


export default QuestionSet;
